export const mfManifestsPath = '/assets/module-federation.manifest.dev5.json'
